// generated from 3_254 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const sessionCountByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("session_count_by_app_filter"),
  comparison_key: z.enum([
    "3", // 2_856 (87.77%)
    "1", // 190 (5.84%)
    "5", // 114 (3.50%)
    "4", // 92 (2.83%)
    "6", // 2 (0.06%)
  ]),
  display_name: z.object({
    // undefined: 3_248 (99.82%), defined 6 (0.18%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 512 (15.73%), defined 2_742 (84.27%)
  raw_value: z.int().min(0).optional(),
  // avg: 0.94, min: 0, max: 500
  value: z.int().min(0),
  varies_by_app_group: z.literal(false),
});
